const CHAIN_ID: Record<string, number> = {
  ethereum: 1,
  eth: 1,
  erc20: 1,
  bsc: 56,
  bep20: 56,
  binance: 56,
  polygon: 137,
  matic: 137,
  pol: 137,
  arbitrum: 42161,
  optimism: 10,
  base: 8453,
  avalanche: 43114,
};

const TOKENS: Record<
  string,
  Record<string, { contract: string; decimals: number }>
> = {
  bsc: {
    USDT: {
      contract: "0x55d398326f99059fF775485246999027B3197955",
      decimals: 18,
    },
    USDC: {
      contract: "0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d",
      decimals: 18,
    },
  },
  ethereum: {
    USDT: {
      contract: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
      decimals: 6,
    },
    USDC: {
      contract: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
      decimals: 6,
    },
  },
  polygon: {
    USDT: {
      contract: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F",
      decimals: 6,
    },
    USDC: {
      contract: "0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359",
      decimals: 6,
    },
  },
};

function toBaseUnits(amount: number, decimals: number) {
  const value = String(amount);
  if (!/^\d+(\.\d+)?$/.test(value)) return null;
  const [whole, fraction = ""] = value.split(".");
  const padded = fraction.padEnd(decimals, "0").slice(0, decimals);
  return BigInt(whole + (decimals ? padded : "")).toString();
}

function chainIdFor(network: string) {
  const net = network.toLowerCase().replace(/\s+/g, "");
  if (CHAIN_ID[net]) return CHAIN_ID[net];
  if (net.includes("bsc") || net.includes("bep")) return 56;
  if (net.includes("polygon") || net.includes("matic")) return 137;
  if (net.includes("eth")) return 1;
  return 1;
}

function tokenNetworkKey(network: string) {
  const net = network.toLowerCase();
  if (net.includes("bsc") || net.includes("bep") || net.includes("binance")) {
    return "bsc";
  }
  if (net.includes("polygon") || net.includes("matic") || net.includes("pol")) {
    return "polygon";
  }
  return "ethereum";
}

export function generateCryptoQrString(
  walletAddress: string,
  network: string,
  amount?: number,
  currency?: string,
) {
  const address = walletAddress?.trim();
  if (!address) return "";

  const symbol = (currency || "").toUpperCase();
  const chainId = chainIdFor(network);
  const isNative =
    !symbol || ["ETH", "BNB", "MATIC", "POL", "AVAX"].includes(symbol);

  if (isNative) {
    const value =
      amount != null ? toBaseUnits(amount, 18) : null;
    return `ethereum:${address}@${chainId}${value ? `?value=${value}` : ""}`;
  }

  const token = TOKENS[tokenNetworkKey(network)]?.[symbol];
  if (!token) return address;

  const amountBase = amount != null ? toBaseUnits(amount, token.decimals) : null;
  const params = [`address=${address}`];
  if (amountBase) params.push(`uint256=${amountBase}`);
  return `ethereum:${token.contract}@${chainId}/transfer?${params.join("&")}`;
}

export function orderIdFromPaymentUrl(paymentUrl?: string | null) {
  if (!paymentUrl) return "";
  try {
    const url = new URL(paymentUrl);
    const fromQuery =
      url.searchParams.get("orderId") ||
      url.searchParams.get("order_id");
    if (fromQuery) return fromQuery;
    const parts = url.pathname.split("/").filter(Boolean);
    return parts[parts.length - 1] || "";
  } catch {
    return "";
  }
}
